import { commonUtils } from '../components/common_utils';
import { adListingAutoLoad } from '../advance_dealer/ad_listing_autoload_sds_ads';
import '../advance_dealer/search_form';
import { counters } from '../components/counters';

export const dealerSite = {
    dealerSiteId: $('#app').data('dealersite-id'),
};

$(function () {
    let $body = $('body');
    let $dealerSearchForm = $('#dealerSearchForm');
    // Listing page: Initialize pagination auto loading
    adListingAutoLoad.init({
        formElementId: 'dealerSearchForm',
        elementToListData: 'listMoreData',
        requestUrl: Routing.generate('simple_dealer_list_ads', { userId: $('#app').data('dealersite-id') }),
    });

    // Listing page: show/hide more content link
    $body.on('click', '.showMoreLine', function () {
        $(this).parent().prev().css({ height: 'auto', overflow: 'visible' });
        $(this).hide();
    });

    // Listing page: sorting option
    $('#dealerSearchSorting').change(function () {
        let sortValue = $(this).val().split('_');
        $dealerSearchForm.find('#sortCol').val(sortValue[0]);
        $dealerSearchForm.find('#ord').val(sortValue[1]);
        $dealerSearchForm.submit();
    });

    // Display map for contact us page
    if ($('#dealerSiteContactUs').length && window.$('#cmp_consent').data('google-map')) {
        let $loadGoogleMap = $('.loadGoogleMap');
        commonUtils.loadEmbedMap($loadGoogleMap.data('map-address'), $loadGoogleMap.data('map-canvas-name'));
    }

    // Display map in modal for Show Map link
    $body.on('click', '.googleMapConsentMessageSDS', function () {
        // Use `window.` because data is set after page load
        if (!window.$('#cmp_consent').data('google-map')) {
            commonUtils.showConsentMessage();
            return false;
        }

        let address = $(this).data('map-address');
        let canvas_name = $(this).data('map-canvas-name');
        window.$.colorbox({
            inline: true,
            href: '#bubble_map_sds',
            onComplete() {
                commonUtils.loadEmbedMap(address, canvas_name, 300, 304);
            },
        });

        return undefined;
    });

    $('a[id^=dealerWebsiteLink]').click(function () {
        counters.incrementByType('dealer-website');
        $.ajax({
            type: 'GET',
            url: Routing.generate('update_dealer_site_counter'),
            data: `dealerId=${$(this).data('dealer-id')}`,
        });
    });

    // Share twitter url
    $body.on('click', '.shareTwitterUrl', function () {
        commonUtils.openNewWindow($(this).data('twitter-share-url'), 660, 430, '', 250, 200);
        commonUtils.dataLayer.shareButtonDataLayerEvent('Twitter');
    });

    $('.deliveryTooltipSds, .warrantyTooltipSds').click(function () {
        const elementData = $(this).data();
        const $currentTooltip = $(`#${elementData.tooltipName}TooltipId_${elementData.id}`);
        // Hide all tooltips other than the current one
        $('.badge-with-info__tooltip').not($currentTooltip).hide();
        // Toggle the current tooltip visibility
        $currentTooltip.toggle();
    });

    $('.vinInfoIcon').click(function () {
        $(this).next('.vinInfoIconToolTip').toggle(); // Toggle the next sibling (tooltip)
    });
});
